import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const PLACE_WORD = { 1: "first", 2: "second", 3: "third" };
const TYPE_WORD = { concours: "Concours", street_race: "Street" };

function ordinal(place) {
  const number = Number(place);
  const tail = number % 100;
  if (tail >= 11 && tail <= 13) {
    return `${number}th`;
  }
  if (number % 10 === 1) {
    return `${number}st`;
  }
  if (number % 10 === 2) {
    return `${number}nd`;
  }
  if (number % 10 === 3) {
    return `${number}rd`;
  }
  return `${number}th`;
}

function placeBadge(item) {
  const type = TYPE_WORD[item.division] || "";
  const word = PLACE_WORD[Number(item.place)];
  const phrase = word ? `${word} place winner` : item.trophy || "Class winner";
  return {
    type,
    mark: word ? ordinal(item.place) : "",
    phrase,
    name: [type, phrase].filter(Boolean).join(" "),
  };
}

function WinnerPhotoCard({ item, compact = false, newTab = false }) {
  const photos = item.photos || [];
  const [index, setIndex] = useState(0);
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    if (!hovering || photos.length < 2) {
      return undefined;
    }
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % photos.length);
    }, 5600);
    return () => window.clearInterval(timer);
  }, [hovering, photos.length]);

  const car = item.vehicle_name || "";
  const person = item.winner_name || "";
  const line = [car, person].filter(Boolean).join(" · ");
  const badge = placeBadge(item);
  const label = [badge.name, item.car_class_title, line].filter(Boolean).join(", ");

  return (
    <Link
      className="winner-photo-card"
      to={`/show/${item.event}?class=${item.event_class}&winner=${item.id}`}
      aria-label={newTab ? `${label}. Opens in a new tab` : label}
      target={newTab ? "_blank" : undefined}
      rel={newTab ? "noreferrer" : undefined}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onFocus={() => setHovering(true)}
      onBlur={() => setHovering(false)}
    >
      <span className="winner-photo-frame">
        {photos.map((src, photoIndex) => (
          <img
            key={src}
            src={src}
            alt=""
            className={photoIndex === index % photos.length ? "is-on" : ""}
          />
        ))}
      </span>
      <span className={compact ? "winner-photo-place is-mark" : "winner-photo-place"}>
        {badge.type && !compact ? <span className="winner-photo-type">{badge.type}</span> : null}
        {badge.mark ? (
          <span className={`winner-photo-mark is-${Number(item.place)}`} aria-hidden="true">
            {badge.mark}
          </span>
        ) : null}
      </span>
      <span className="winner-photo-caption">
        {compact ? null : <span className="winner-photo-title">{item.car_class_title}</span>}
        {line ? <span>{line}</span> : null}
      </span>
    </Link>
  );
}

export default WinnerPhotoCard;
